<template>
  <!--This is the article dialog, which opens from the front page-->
  <v-card v-if="currentTranslation">
    <div style></div>
    <v-btn style="position: absolute; top: 0; right: 0px; z-index: 10000;" icon color="info" :to="{name: `frontpage`, params: {}}" replace>
      <v-icon>close</v-icon>
    </v-btn>
    
    <v-row>
      <v-col md="auto">
        <p class="headline">{{currentTranslation.Title}}</p>
        <span class="font-weight-bold"> Users_id : {{articledata.Users_id}} </span>
        <span class="font-italic">{{$t('Posted')}}: {{articledata.Created | moment('LL') }}</span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col md="auto">
        <v-img v-if="articledata.Media && articledata.Media.length > 0" :src="`${articledata.Media[0]['s3url']}-web.jpg`" style="width:100%;" max-height="400px" :ratio="1"></v-img>
        <v-img v-else :src="`/wenewz_middle_2color.svg`" width="100%" :ratio="1.77"></v-img>
      </v-col>
    </v-row>



    <v-card-title>
      <span class="headline">{{currentTranslation.Title}}</span>
    </v-card-title>
    <v-card-text>
      <span class="font-weight-bold"> Users_id : {{articledata.Users_id}} </span>
      <span class="font-italic">{{$t('Posted')}}: {{articledata.Created | moment('LL') }}</span>
      <br />
      <v-chip v-for="tag in articledata.GeoTags" :key="tag.id" color="green" text-color="white">
        {{tag.Label}}
        <v-icon right>navigation</v-icon>
      </v-chip>
      <v-chip v-for="tag in articledata.Tags" :key="tag.id" color="orange" text-color="white">
        {{tag.Label}}
        <v-icon right>short_text</v-icon>
      </v-chip>
    </v-card-text>
    <v-card-text>
      <!-- <pre>{{articledata}}</pre> -->
      <div v-html="currentTranslation.Content" class="body-1" style="white-space:pre-wrap;"></div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["articledata"],
  data() {
    return {
      currentLang:
        localStorage.getItem("setlanguage") ||
        localStorage.getItem("detectedlanguage") ||
        "en"
    };
  },
  computed: {
    currentTranslation() {
      return (
        this.articledata.Content.find(el => el.Lang == this.currentLang) ||
        this.articledata.Content.find(
          el => el.Lang == this.articledata.OrgLanguage
        )
      );
    }
  }
};
</script>

<style scoped>
/* v-card v-img {
  max-width: 100%;
  height: auto;
} */
</style>